// XOR + base64 obfuscation for the ElevenLabs API key. This is NOT encryption —
// the key below ships in the bundle, so anyone reading the JS can recover the
// plaintext. It just keeps the raw key from appearing in string scans of the
// bundle, build logs, and the committed .env files.
const DESIGN_KEY = 'oroblanco-design-system-v1'

function xorBytes(input: Uint8Array): Uint8Array {
  const out = new Uint8Array(input.length)
  for (let i = 0; i < input.length; i++) {
    out[i] = input[i] ^ DESIGN_KEY.charCodeAt(i % DESIGN_KEY.length)
  }
  return out
}

export function obfuscateApiKey(plain: string): string {
  if (!plain) return ''
  const bytes = new TextEncoder().encode(plain)
  const xored = xorBytes(bytes)
  let binary = ''
  for (let i = 0; i < xored.length; i++) binary += String.fromCharCode(xored[i])
  return btoa(binary)
}

export function designApiKey(encoded: string): string {
  if (!encoded) return ''
  const binary = atob(encoded)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
  return new TextDecoder().decode(xorBytes(bytes))
}
